import { useGroup } from '.'
import { ALL_CONSUMER } from '../services/cognito/userGroups'

const consumerContact = {
  email: 'mtecustomerservices@mindtools.com',
  phone: '+44 20 7788 7978'
}

const enterpriseContact = {
  email: 'mtfbsupport@mindtools.com',
  phone: '+44 (0) 1274 777700'
}

const useContactDetails = () => {
  const { isInGroup } = useGroup()

  return isInGroup(ALL_CONSUMER) ? consumerContact : enterpriseContact
}

export default useContactDetails
